module.exports = __webpack_public_path__ + "static/media/fact-checker-banner.44bc6102.png";